export type ApproverRoleEnum = 'reviewer' | 'approver' | 'owner';
export const ApproverRoleEnum = {
  Reviewer: 'reviewer' as ApproverRoleEnum,
  Approver: 'approver' as ApproverRoleEnum,
  Owner: 'owner' as ApproverRoleEnum
};
